import src from "IMAGE";
export default { src, width: 809, height: 717, blurWidth: 0, blurHeight: 0};
